export default __webpack_public_path__ + "static/media/sc3.2626a5af.png";